import { render, staticRenderFns } from "./goodsEdit.vue?vue&type=template&id=84bdea9a&scoped=true"
import script from "./goodsEdit.vue?vue&type=script&lang=js"
export * from "./goodsEdit.vue?vue&type=script&lang=js"
import style0 from "./goodsEdit.vue?vue&type=style&index=0&id=84bdea9a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84bdea9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84bdea9a')) {
      api.createRecord('84bdea9a', component.options)
    } else {
      api.reload('84bdea9a', component.options)
    }
    module.hot.accept("./goodsEdit.vue?vue&type=template&id=84bdea9a&scoped=true", function () {
      api.rerender('84bdea9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/goodsEdit.vue"
export default component.exports